import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import frameFormulario from '../../assets/img/frame-formulario.svg';

function CardAgradecimento({ setBannerAgradecimento, resumido }) {
  return (
    <Box
      data-testid="card-agradecimento"
      className={`msg-finalizacao ${resumido ? 'resumido' : ''}`}
    >
      <Box>
        <Box>
          <img data-testid="logo-img" src={frameFormulario} alt="logo" />
        </Box>
        <Typography
          data-testid="titulo-text"
          className="texto-cor-cinza font-bold-600 margin-top-25"
          variant="h5"
        >
          Recebemos seu contato
        </Typography>

        <Box className="margin-top-15">
          <Typography
            data-testid="mensagem-text"
            className="margin-top-15 font-bold-600"
            variant="h7"
          >
            Vamos retornar por e-mail ou telefone o mais rápido possível.
          </Typography>
        </Box>

        <Box className="margin-top-25">
          <Button
            data-testid="botao-voltar"
            className="button-banner-voltar"
            onClick={() => setBannerAgradecimento(false)}
          >
            Voltar
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default CardAgradecimento;
